import { a } from '../global-constants';

const account = (state = {}, { type, payload }) => {
	switch (type) {
		case a.SET_ACCOUNT: {
			return {
				...state,
				...payload
			};
		}
		default:
			return state;
	}
};

export default account;
